/** @format */

import React from 'react';

import {Button} from '@sttark/design-system';

import uploadFilesIcon from './assets/upload-files.svg';

export default function UploadFile({
    compact,
    multiple,
    dropping,
    numUploaded = 0,
    numUploading = 0,
    text,
    onClick
}) {
    const hasUploaded = numUploaded > 0;
    const canUploadMore = numUploaded <= 0 || multiple;
    const uploadInProgress = numUploading > 0;

    let buttonText = multiple ? 'Upload design files' : 'Upload file';
    if (uploadInProgress) {
        buttonText =
            numUploading === 1 ? 'Processing file...' : `Processing ${numUploading} files...`;
    }

    // Unless explicitly provided as a prop, use compact mode after files have been uploaded.
    compact = compact == null ? hasUploaded : !!compact;

    if (text == null) {
        if (compact) {
            if (multiple) {
                text = hasUploaded
                    ? 'Upload more design files or drop them here'
                    : 'Upload or drop files here';
            } else {
                text = 'Upload or drop your file here';
            }
        } else {
            if (multiple) {
                text = hasUploaded ? 'or drop more files to upload' : 'or drop files to upload';
            } else {
                text = 'or drop your file here';
            }
        }
    }
    return (
        <div
            className={`p-4 my-4 content-box border-dashed border-all ${
                dropping ? 'border-accent-primary bg-structure-lighter' : ''
            }`}>
            {compact ? (
                <>
                    <div className="d-flex align-items-center">
                        <img className="me-4" src={uploadFilesIcon} alt="Upload file icon" />
                        <p className="flex-grow-1 pt-2">{text}</p>
                        <Button
                            disabled={!canUploadMore || uploadInProgress}
                            secondary
                            small
                            label={buttonText}
                            onClick={onClick}
                        />
                    </div>
                </>
            ) : (
                <div className="text-center">
                    <p>
                        <img src={uploadFilesIcon} alt="Upload file icon" />
                    </p>
                    <Button
                        disabled={!canUploadMore || uploadInProgress}
                        secondary
                        label={buttonText}
                        onClick={onClick}
                    />
                    <p className=" pt-2">{text}</p>
                </div>
            )}
        </div>
    );
}
